export default "__VITE_ASSET__DrjG00pH__"